import React, { useState, useEffect } from "react";
import "./LeadCapture.css";

const LeadCapture = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Show popup after 30 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 30000);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      // Using a proxy approach with form data
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("timestamp", new Date().toISOString());
      formDataToSend.append("source", "website_lead_capture");

      const response = await fetch(
        "https://hooks.zapier.com/hooks/catch/20394264/2nmmkuv/",
        {
          method: "POST",
          body: formDataToSend,
        }
      );

      // Check if the response is ok (status in the range 200-299)
      if (response.ok) {
        setIsSubmitted(true);
        setFormData({ name: "", email: "" }); // Clear the form

        // Hide the popup after 3 seconds
        setTimeout(() => {
          setIsVisible(false);
        }, 3000);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error submitting lead:", error);

      // More specific error messages based on the error type
      if (error.name === "TypeError" && error.message === "Failed to fetch") {
        setError(
          "Network error. Please check your internet connection and try again."
        );
      } else if (error.message.includes("HTTP error")) {
        setError("Server error. Please try again later.");
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <>
      {/* Footer Form */}
      <div className="lead-capture-footer">
        <h4>Stay Updated!</h4>
        <p>Get exclusive offers and maintenance tips</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Submitting..." : "Subscribe"}
          </button>
          {error && <p className="error-message">{error}</p>}
        </form>
      </div>

      {/* Popup Form */}
      {isVisible && (
        <div className="lead-capture-popup-overlay">
          <div className="lead-capture-popup">
            <button className="close-button" onClick={handleClose}>
              ×
            </button>
            <div className="popup-content">
              <h3>Get Exclusive Offers!</h3>
              <p>Subscribe to receive special discounts and maintenance tips</p>
              {!isSubmitted ? (
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
                  <button type="submit" disabled={isLoading}>
                    {isLoading ? "Submitting..." : "Get Special Offers"}
                  </button>
                  {error && <p className="error-message">{error}</p>}
                </form>
              ) : (
                <div className="success-message">
                  <p>Thank you for subscribing!</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LeadCapture;
